import { str_validate_email } from 'helpers';
import get from 'lodash/get';
import { commonStore } from 'stores';
import { v4 as uuidv4 } from 'uuid';
import analytics from 'tracking/analytics';

/* Common purchase events */

export const sendPurchaseEvent = () => {
    const event_id = uuidv4();
    window.dataLayer.push({
        event: 'Purchase',
        userId: get(commonStore, 'user.id'),
        eventID: event_id,
    });
    analytics.trackPurchaseEvent({
        fb_conversions_api_event_id: event_id,
    });
};

export const sendPaymentPageViewEvent = () => {
    window.dataLayer.push({
        event: 'PaymentPageView',
    });
};

export const sendThankYouPageView = (price: any) => {
    const userEmail = get(commonStore, 'user.email');

    if (str_validate_email(userEmail)) {
        window.dataLayer.push({
            event: 'ThankYouPageViewConversion',
            conversionValue: price.amount,
            conversionCurrency: price.currency,
            userEmail: userEmail,
        });
    }
    window.dataLayer.push({
        event: 'ThankYouPageViewAnalytics',
    });
};

export const sendSignupPageView = () => {
    window.dataLayer.push({
        event: 'SignupPageView',
    });
};

/* Gift purchase events */

export const sendGiftCheckoutPageView = () => {
    window.dataLayer.push({
        event: 'GiftCheckoutPageView',
    });
};

export const sendGiftCustomisePageView = () => {
    window.dataLayer.push({
        event: 'GiftCustomisePageView',
    });
};

export const sendGiftLandingPageView = () => {
    window.dataLayer.push({
        event: 'GiftLandingPageView',
    });
};

export const sendGiftSuccessPageView = () => {
    window.dataLayer.push({
        event: 'GiftSuccessPageView',
    });
};

/* Campaign specific events */

export const sendBlackFridayPageView = () => {
    window.dataLayer.push({
        event: 'BlackFridayPageView',
    });
};

export const sendJasonMrazPageView = () => {
    window.dataLayer.push({
        event: 'JasonMrazPageView',
    });
};

export const sendNewYearPageView = () => {
    window.dataLayer.push({
        event: 'NewYearPageView',
    });
};

export const sendAprilDiscountPageView = () => {
    window.dataLayer.push({
        event: 'AprilDiscountPageView',
    });
};
